import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { ParcDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-parc-select',
  templateUrl: './parc-select.component.html',
  styleUrls: ['./parc-select.component.css']
})
export class ParcSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.parcs$) parcs$: Observable<ParcDto[]>;

  @Input() width: number;
  @Input() widthPopUp: number = 250;
  
  @Input() public required: boolean = false;

  @Input() filterParcId: number;
  @Input() parcId: number;
  @Input() titleNull: string;
  @Output() parcIdChange = new EventEmitter<number>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  Parcs: ParcDto[] = [];
  ColumnName = [];

  p: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Identifiant',
        'Designation'
      ]
      ).subscribe(translations => {
        this.ColumnName.push(translations['Identifiant']);
        this.ColumnName.push(translations['Designation']);
      });
  }

  ngOnInit() {
    if(this.parcId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.parcId));
    }
    this.p = this.parcs$.subscribe(res => {
      if (res != null) {
        this.Parcs = res.sort((p1, p2) => p1.Identifiant.localeCompare(p2.Identifiant));

        if (this.filterParcId) {
          this.Parcs = this.Parcs.filter(p => p.Id === this.filterParcId);
        } else {
          if (this.titleNull && !this.Parcs.find(p => p.Id == 0)) {
            this.Parcs.unshift({ Id: 0, Identifiant: this.titleNull, Designation: this.titleNull });
          }
        }

      }
    });
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }

  updateInfo(event) {
    this.parcId = event.currentSelectedRowKeys.length == 1 ? event.currentSelectedRowKeys[0].Id : this.parcId;
    if (!!this.cell && this.InitId != this.parcId) {
      this.cell.setValue(this.parcId);
    }
    this.parcIdChange.emit(this.parcId);

    if(this.parcId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.parcId == null) {
      this.dataGrid.instance.clearSelection();
    }

    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}
